// extracted by mini-css-extract-plugin
module.exports = {"content":"switch-mode_content__1SWTK","toggle":"switch-mode_toggle__1D-RQ","slider":"switch-mode_slider__3MtQO","hideText":"switch-mode_hideText__142dz"};